var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_x",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1542",
    "data-name": "\\uC0AC\\uAC01\\uD615 1542",
    width: 30,
    height: 30,
    fill: "#b9b9b9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_546",
    "data-name": "\\uADF8\\uB8F9 546",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1434",
    "data-name": "\\uD328\\uC2A4 1434",
    d: "M15,3.755A11.676,11.676,0,1,1,9.121,5.349,11.6,11.6,0,0,1,15,3.755m4.83,15.723-3.418-4.057,3.418-4.056a1.046,1.046,0,0,0-.09-1.5,1.1,1.1,0,0,0-1.551.092L15,13.736,11.81,10a1.024,1.024,0,0,0-1.5-.137,1.074,1.074,0,0,0-.137,1.551l3.418,4.009-3.418,4.01a1.074,1.074,0,0,0,.137,1.551.975.975,0,0,0,.636.273,1.088,1.088,0,0,0,.867-.365L15,17.107l3.189,3.783a1.04,1.04,0,0,0,.821.365.926.926,0,0,0,.683-.273,1.024,1.024,0,0,0,.137-1.5",
    fill: "#b9b9b9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGray);
export default __webpack_public_path__ + "static/media/x-gray.26131decfd5b69b0c9f6f58412383c97.svg";
export { ForwardRef as ReactComponent };